var styles = {"area-sub-name":"HeaderBrandDepth-module_area-sub-name__iq2fo","sub-name":"HeaderBrandDepth-module_sub-name__t-5rA"};

export { styles as default };
